export const SERVER_ERROR_TYPES = {
  itemAlreadyExistException: "/errors/item-already-exists",
  concurrencyException: "/errors/concurrency",
  argumentException: "/errors/argument",
  jsonPatchException: "/errors/json-patch",
  unauthorizedAccessException: "/errors/unauthorized",
  itemNotFoundException: "/errors/not-found",
  forbiddenException: "/errors/forbidden",
  invalidOperationException: "/errors/internal",
  ipForbiddenException: "/errors/ip-forbidden",
  unknown: "/errors/unknown",
} as const;

export type ServerErrorType = (typeof SERVER_ERROR_TYPES)[keyof typeof SERVER_ERROR_TYPES];

export interface ServerErrorBody {
  type: ServerErrorType;
  title: string;
  status: number;
  detail: string;
  instance: string;
}
